
import React, { useState, useEffect, Fragment, useRef } from 'react'
import {
  Select, Form, Input, Button, Modal,
  Upload, Row, Col, DatePicker, message, InputNumber, Space, Radio, TreeSelect, Tree
} from "antd";
const { RangePicker } = DatePicker;
// import { LoadingOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
// import HandleButton from "@/components/HandleButton"
import RoleApi from '@api/role'

import ResourceApi from '@api/resource'
// import Title from '@/components/Title'
// import MinTitle from '@/components/MinTitle'
// import MessageApi from '@api/message'
import AddModal from '@components/Modal'
// import moment from 'moment';
// const { UPLOADER } = window.globalConfig;
import { alarmApi, stationApi, dictApi } from "@api/newApi";
import InspectionApi from '@api/inspectionnew'
import { treeConversion, treeIds, extraIds } from '@utils/common'

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 17 },
};
const { SHOW_PARENT, SHOW_ALL, TreeNode } = TreeSelect;
const Option = Select.Option
let childIds = ''
export default ({ title, visible, formData = null, cancel, stationData }) => {
  const [form] = Form.useForm();
  const [editBool, setEditBool] = useState(false)
  const [resourceTree, setResourceTree] = useState()
  const [formValue, setFormValue] = useState()
  const [loading, setLoading] = useState()
  // 所有的树形id
  const [allIds, setAllIds] = useState([])
  const [isManager, setIsManger] = useState(0)

  const [tasls, setTask] = useState()
  // 厂站集合
  const [patrolItemParams, setPatrolItemParams] = useState({
    stationId: '',
    type: '',
    materielId: '',
    processunitClassifyId: '',
    processunitId: '',
    deviceClassifyId: '',
  })

  useEffect(() => {
    InspectionApi.taskQuery({pageNum:1,pageSize:100}).then(res => {
     
      if (res.status == 0 && res.data) {
        setTask(res.data.data || [])
      }
    })
    return () => { }
  }, [visible])

 
  // 切换厂站，查询巡检项
  const changeStation = (val) => {
    let type = form.getFieldValue('type')
    let stationId = form.getFieldValue('stationId')
    if (type === 0) {
      setPatrolItemParams(
        {
          ...patrolItemParams,
          stationId,
          type
        }
      )
    } else if (stationId) {
      InspectionApi.selectPatrolItemByStation(stationId)
        .then((res) => {
          if (res.status == 0) {
            // setPatrolItems(res.data);
            form.setFieldsValue({ 'itemContent': res.data[0].item })
          }
        })
    }
  }
  // 提交
  const submit = () => {
    
  
    form.validateFields().then(values => {
      let param = {
        ...values,
      }
      setLoading(true)
      InspectionApi.taskLeakAdd(param).then(res => {
        if (res.status == 0) {
          message.success('新建成功')
          handelCancel()
        }
        setLoading(false)
      }).catch((err) => {
        setLoading(false)
      })
    })
  }
  // 取消
  const handelCancel = () => {
    form.resetFields();
    cancel(false);
  }
  // 切换类型
  const handleChangePerson = (e) => {
    changeStation()
    setIsManger(e)
  }
  const handleChangeTree = (values, label, extra) => {
    // console.log(`selectd: ${values}`, extra.allCheckedNodes)
    // if (extra) {
    //   let ids = [...new Set(extraIds(extra.allCheckedNodes).flat(Infinity))]
    //   setAllIds(ids.join(','))
    // } else {
    //   setAllIds('')
    // }
  }

  
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={800} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form
          {...layout}
          // name="basic"
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
          initialValues={formValue}
        >
          {/* <Row> */}
          <Col span={18}>
            <Form.Item
              label='任务名称'
              name="taskId"
              rules={[{ required: true, message: '请选择任务名称' }]}
            >
              
              <Select
                onChange={(val) => changeStation(val)}
                placeholder="请选择">
                {
                  tasls && tasls.map((item, idx) => {
                    return (
                      <Select.Option value={item.id } key={'taskId-' + idx}>{item.taskName}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item
              label='站点'
              name="stationId"
              rules={[{ required: true, message: '请选择站点' }]}
            >
              <Select
                placeholder="请选择站点">
                {
                  stationData.map((item) => {
                    return (
                      <Select.Option value={item.value } key={item.value}>{item.title}</Select.Option>
                    )
                  })
                }
              </Select>
            </Form.Item>
          </Col>
          <Col span={18}>
                <Form.Item label='巡检人' name='person' rules={[{ required: true, message: '请选择巡检人' }]}>
                  <Select placeholder="请选择巡检人">
                    <Select.Option value="0">张三</Select.Option>
                    <Select.Option value="1">李四</Select.Option>
                    <Select.Option value="2">王五</Select.Option>
                    <Select.Option value="3">赵六</Select.Option>
                  </Select>
                </Form.Item>
          </Col>
          <Col span={18}>
                <Form.Item label='巡检标准' name='standard' rules={[{ required: true, message: '请选择巡检标准' }]}>
                  <Select placeholder="请选择巡检标准">
                    <Select.Option value="0">巡检标准1</Select.Option>
                    <Select.Option value="1">巡检标准2</Select.Option>
                    <Select.Option value="2">巡检标准3</Select.Option>
                    <Select.Option value="3">巡检标准4</Select.Option>
                  </Select>
                </Form.Item>
          </Col>
          <Col span={18}>
                <Form.Item label='时间' name='time' rules={[{ required: true, message: '请选择巡检时间' }]}>
                  <RangePicker
                    showTime={{
                      format: 'HH:mm',
                    }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>
          </Col>
          <Col span={18}>
            <Form.Item label='漏检说明' name="leakDesc" rules={[{ required: true, message: '请填写捡漏说明!' }]}>
                <Input.TextArea row={4} placeholder={'巡检内漏检说明容'} />
              </Form.Item>
          </Col>
          
          {/* </Row> */}
        </Form>
      </div>
    </AddModal>
  )

}
